import {
    AddLocalTravelDataRequest,
    CreateAgencyRequest,
    CreateAgencyResponse,
    EditAgencyProfileResponse,
    Flag,
    GetAgencyNameResponse,
    GetAgencyBranchesResponse,
    GetAgencyPoliciesResponse,
    GetAgencyQuotationsResponse,
    GetAgencyStatisticsResponse,
    GetAllIntermedialyTypes,
    GetQuotationsReportResponse,
    GetSingleAgencyResponse,
    GetUnsupervisedAgencies,
    PolicyStatus,
    QuoteStatus,
    CancelTravelScheduleRequest
} from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';
import { GetAllAgenciesResponse } from 'Application/models/dto/response/GetAllAgenciesResponse';
import dayjs from 'dayjs';
import { convertJsonToBlob } from 'Application/utils';
import { AgencyLocalTravelData, GetAgencyLocalTravelDataResponse } from 'Application/models/dto/response/GetAgencyLocalTravelData';

export const createAgencyCompany = async (createAgencyData: CreateAgencyRequest) => {
    const url = '/api/v1/agency';

    const { agency } = createAgencyData;
    let { branchCode, agentNumber, ...agencyDetails } = agency;

    // let {{ branchCode, agentNumber, ...agencyDetails }} = createAgencyData;

    agencyDetails = {
        ...agencyDetails,
        ...(branchCode && { branchCode }),
        ...(agentNumber && { agentNumber })
    };

    const formData = new FormData();
    formData.append('agency', convertJsonToBlob(agencyDetails));

    try {
        const response: AxiosResponse<CreateAgencyResponse> = await APICallInstance.post(url, formData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const EditAgencyCompany = async (formData: FormData, agencyId: any) => {
    const url = `/api/v1/agency/profile/${agencyId}`;

    try {
        const response: AxiosResponse<EditAgencyProfileResponse> = await APICallInstance.patch(url, formData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAgencies = async (region?: string | null, page?: number, pageSize?: number, searchValue?: string) => {
    const url = 'api/v1/agency';

    try {
        const response: AxiosResponse<GetAllAgenciesResponse> = await APICallInstance.get(url, {
            params: {
                ...(region !== undefined && region !== null && { region: region }),
                ...(page !== undefined && { page: page }),
                ...(pageSize !== undefined && { pageSize: pageSize }),
                ...(searchValue !== undefined && searchValue !== '' && { searchValue: searchValue })
            }
        });
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const fetchAgenciesNames = async () => {
    const url = 'api/v1/agency/name';

    try {
        const response: AxiosResponse<GetAgencyNameResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchIntermediaryType = async (intermediaryType: string) => {
    const url = `api/v1/agency/filter-by-intermediary-type?intermediaryType=${intermediaryType}`;

    try {
        const response: AxiosResponse<GetAllIntermedialyTypes> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const fetchUnsupervisedAgenciesNames = async () => {
    const url = 'api/v1/agency/unsupervised';

    try {
        const response: AxiosResponse<GetUnsupervisedAgencies> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchSingleAgency = async (agencyId: any) => {
    const url = `api/v1/agency/profile/${agencyId}`;

    try {
        const response: AxiosResponse<GetSingleAgencyResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchAgencyStatistics = async (agencyName: string) => {
    const url = `api/v1/agency/statistics/?agencyName=${agencyName}`;

    try {
        const response: AxiosResponse<GetAgencyStatisticsResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAgencyPolicies = async (
    agencyName: string,
    pageNumber: number,
    pageSize: number,
    status?: PolicyStatus,
    policyNumber?: string,
    startDate?: string,
    endDate?: string
) => {
    const url = `/api/v1/agency/policies`;

    try {
        const response: AxiosResponse<GetAgencyPoliciesResponse> = await APICallInstance.get(url, {
            params: {
                agencyName: agencyName,
                page: pageNumber,
                pageSize: pageSize,
                ...(status !== undefined && { status }),
                ...(policyNumber ? { policyNumber } : {}),
                ...(startDate ? { startDate: dayjs(startDate).format('YYYY-MM-DD') } : {}),
                ...(endDate ? { endDate: dayjs(endDate).format('YYYY-MM-DD') } : {})
            }
        });

        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAgencyQuotations = async (
    agencyId: number,
    pageNumber: number,
    pageSize: number,
    status?: QuoteStatus,
    search?: string
) => {
    const url = `/api/v1/quotation/agency/${agencyId}`;

    try {
        const response: AxiosResponse<GetAgencyQuotationsResponse> = await APICallInstance.get(url, {
            params: {
                agencyId: agencyId,
                page: pageNumber,
                pageSize: pageSize,
                ...(status !== undefined && { status: status }),
                ...(search !== undefined && { search: search })
            }
        });

        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getBritamInternalUsersQuotations = async (
    pageNumber: number,
    pageSize: number,
    flag: Flag,
    status?: QuoteStatus,
    search?: string,
    agencyName?: string,
    region?: string,
    startDate?: string,
    endDate?: string
) => {
    const url = `/api/v1/quotation`;

    try {
        const response: AxiosResponse<GetAgencyQuotationsResponse> = await APICallInstance.get(url, {
            params: {
                page: pageNumber,
                pageSize: pageSize,
                flag: flag,
                ...(status !== undefined && { status: status }),
                ...(search !== undefined && { searchTerm: search }),
                ...(agencyName !== undefined && { agencyName: agencyName }),
                ...(region !== undefined && region !== 'All' && { regionName: region }),
                ...(startDate !== undefined && { startDate: dayjs(startDate).format('YYYY-MM-DD') }),
                ...(endDate !== undefined && { endDate: dayjs(endDate).format('YYYY-MM-DD') })
            }
        });

        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getQuotationsReportData = async (
    search?: string,
    status?: QuoteStatus,
    agencyName?: string,
    regionName?: string,
    startDate?: string,
    endDate?: string
) => {
    const url = `/api/v1/quotation/report`;

    try {
        const response: AxiosResponse<GetQuotationsReportResponse> = await APICallInstance.get(url, {
            params: {
                ...(search !== undefined && { searchTerm: search }),
                ...(status !== undefined && { status: status }),
                ...(agencyName !== undefined && { agencyName: agencyName }),
                ...(regionName !== undefined && regionName !== 'All' && { regionName: regionName }),
                ...(startDate !== undefined && { startDate: dayjs(startDate).format('YYYY-MM-DD') }),
                ...(endDate !== undefined && { endDate: dayjs(endDate).format('YYYY-MM-DD') })
            }
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAgencyLocalTravelData = async (intermediary: string, page?: number, pageSize?: number) => {
    const url = `/api/v1/agency/perks`;

    try {
        const response: AxiosResponse<GetAgencyLocalTravelDataResponse> = await APICallInstance.get(url, {
            params: {
                intermediaryName: intermediary,
                ...(page !== undefined && { page }),
                ...(pageSize !== undefined && { pageSize })
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const addAgencyLocalTravelData = async (perksData: AddLocalTravelDataRequest) => {
    const url = `/api/v1/agency/perks`;

    try {
        const response: AxiosResponse = await APICallInstance.post(url, perksData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAgencyBranches = async (agencyName: string) => {
    const url = `/api/v1/agency/branch`;

    try {
        const response: AxiosResponse<GetAgencyBranchesResponse> = await APICallInstance.get(url, {
            params: {
                agencyName
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFilteredAgencyLocalTravelData = async (
    agencyName: string,
    branch?: string,
    svNumber?: string,
    startDate?: string,
    endDate?: string
) => {
    const url = '/api/v1/agency/travel-schedule-report';

    try {
        const response: AxiosResponse<AgencyLocalTravelData[]> = await APICallInstance.get(url, {
            params: {
                intermediaryName: agencyName,
                ...(branch !== undefined && { branch }),
                ...(svNumber !== undefined && { svNumber }),
                ...(startDate !== undefined && { startDate }),
                ...(endDate !== undefined && { endDate })
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateAgencyLocalTravelData = async (perksData: AddLocalTravelDataRequest) => {
    const url = '/api/v1/agency/update-schedule';

    try {
        const response: AxiosResponse = await APICallInstance.patch(url, perksData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const cancelTravelSchedule = async (cancelRequest: CancelTravelScheduleRequest) => {
    const url = '/api/v1/agency/cancel-schedule';

    try {
        const response: AxiosResponse = await APICallInstance.put(url, cancelRequest);
        return response.data;
    } catch (error) {
        throw error;
    }
};
